import type { CurrencyRef } from '@gat-ship/types'
import { getCurrencyRefRequest } from '../model/currency-api-calls'
import { createListRefDataSource } from './create-list-ref-datasource'

/**
 * Shared currency ref cache. Non-debounced (no `debounceMs`) to preserve the
 * immediate, synchronous-after-await fetch timing the unit test relies on. The
 * currency-specific SignalR wiring lives in the composable wrapper.
 */
export const currencyRefDataSource = createListRefDataSource<CurrencyRef>({
  fetch: getCurrencyRefRequest,
  getKey: (currency) => currency.code
})
